import React, { Component } from 'react';
import PropTypes from 'prop-types';
import './HomePage.css';
import HomeIcons from '../shared/homeIcons/HomeIcons.js';
import documentData from '../../constants/documentType.json';

class HomePage extends Component {
    constructor(props) {
        super(props);
        this.navToIntroduction = this.navToIntroduction.bind(this);
        this.navToStepByStep = this.navToStepByStep.bind(this);
        this.navToBestPractise = this.navToBestPractise.bind(this);
        this.navToTechnical = this.navToTechnical.bind(this);
    }

    getHomePageHeading() {
        return 'Welcome to the AllAboutMe resource page. This page is where you can access the latest documentation and templates to help you set up and run your card customization solution.';
    }

    getIntroductionData() {

        return documentData.filter(document => document.folderName == "Introduction")[0];
    }

    getStepByStepData() {
        return documentData.filter(document => document.folderName == "StepByStep")[0];
    }

    getTechnical() {
        return documentData.filter(document => document.folderName == "Technical")[0];
    }

    getBestPractice() {
        return documentData.filter(document => document.folderName == "BestPractice")[0];
    }

    getAsideOnlineMarketing() {
        return {
            'heading': "Online Marketing - How to Maximise your card program!",
            'details': "Using online marketing has proven to be the most successful technique in marketing a Card Customization program. Including a link to the card designer from the online banking page have shown the greatest traffic and submission rates. This makes sense due to the online presence of the cardholder and the ease and attractiveness to an already engaged consumer.",
            'url':'https://www.youtube.com/watch?v=_wS9K43fpp8',
            'action': 'Watch Video'
        }
    }

    getAsideAAMFeatures() {
        return {
            'heading': "New AllAboutMe Feature",
            'details': "Serverside’s New Facebook app uses card customization as a new and unique way to leverage Facebook in an exciting and engaging way that can drive real brand value, loyalty, and engagement from a bank’s customers. Customers can design a card using an image from one of their Facebook photo galleries.",
            'url':'https://www.youtube.com/watch?v=_wS9K43fpp8',
            'action': 'Watch Video'
        }
    }

    getAsideNeedCustomize() {
        return {
            'heading': "Why Customize Cards?",
            'details': "Customize cards are the perfect product to take your online marketing to the next level – and result in a dramatically superior return on your marketing spend.",
            'url':'https://www.youtube.com/watch?v=_wS9K43fpp8',
        }
    }

    navToIntroduction(e) {
        e.preventDefault();
        this.props.history.push('/introduction');
    }

    navToStepByStep(e) {
        e.preventDefault();
        this.props.history.push('/stepByStep');
    }

    navToBestPractise(e) {
        e.preventDefault();
        this.props.history.push('/bestPractice');
    }


    navToTechnical(e) {
        e.preventDefault();
        this.props.history.push('/technical');
    }

    render() {
        const introductionIcon = process.env.BASE_URL + "images/app/info.png";
        // const bestPracticeIcon = process.env.BASE_URL + "images/app/bestPractise.png";
        const stepByStepIcon = process.env.BASE_URL + "images/app/stepByStep.png";
        const technicalIcon = process.env.BASE_URL + "images/app/technical.png";
        // const blogIcon = process.env.BASE_URL + "images/app/blog.png";
        // const brochureIcon = process.env.BASE_URL + "images/app/brochure.png";
        return (
            <div className='home-container'>
                <p className="home-container-text">{this.getHomePageHeading()}</p>
                <div className="home-icons-introduction">
                    <HomeIcons content={this.getIntroductionData()} navToIntroduction={this.navToIntroduction} icon={introductionIcon} />
                </div>
                <div className="home-icons-step">
                    <HomeIcons content={this.getStepByStepData()} navToIntroduction={this.navToStepByStep} icon={stepByStepIcon} />
                </div>
                {/* <div className="home-icons-bestPractice">
                    <HomeIcons content={this.getBestPractice()} navToIntroduction={this.navToBestPractise} icon={bestPracticeIcon} />
                </div> */}
                <div className="home-icons-technical">
                    <HomeIcons content={this.getTechnical()} navToIntroduction={this.navToTechnical} icon={technicalIcon} />
                </div>
                {/* <div className="home-icons-aside-gap"/>
                <div className="home-aside-marketing">
                    <AsideLinks className='aside-online' content={this.getAsideOnlineMarketing()} />
                    <AsideLinks className='aside-AAM-features' content={this.getAsideAAMFeatures()} />
                    <AsideLinks className='aside-customize' content={this.getAsideNeedCustomize()} displayImage={brochureIcon} displayImageHeading={"Click the image to download the Business case brochure."}/>
                    <AsideLinks className='aside-blog' displayImage={blogIcon} displayImageHeading={"Follow our latest product updates on our blog"}/>
                </div> */}
            </div>
        )
    }
}

HomePage.propTypes = {
    history: PropTypes.object
}


export default HomePage;